import { createContext, useContext, useEffect, useState } from "react";

const ScrimContext = createContext()

export const useScrimContext = ()=>{
    return useContext(ScrimContext)
}

const ScrimProvider = ({children}) =>{
    const [data, setData] = useState([])
    useEffect(()=>{
        setData({
            "success": true,
            "data": [
                {
                    "_id": "634a44c1403dfbbd3ecd147b",
                    "name": "SOLO",
                    "game": {
                        "titles": [
                            {
                                "name": "Map",
                                "value": "Map"
                            },
                            {
                                "name": "Perspective",
                                "value": "Perspective"
                            }
                        ],
                        "title1Values": [
                            {
                                "name": "Map1",
                                "value": "Bermuda",
                                "_id": "634cee7204ebfff45242933e"
                            },
                            {
                                "name": "Map2",
                                "value": "Bermuda Remastered",
                                "_id": "634cee7204ebfff45242933f"
                            },
                            {
                                "name": "Map3",
                                "value": "Alpain",
                                "_id": "634cee7204ebfff452429340"
                            },
                            {
                                "name": "Map4",
                                "value": "Puragatory",
                                "_id": "634cee7204ebfff452429341"
                            },
                            {
                                "name": "Map5",
                                "value": "Kalahari",
                                "_id": "634cee7204ebfff452429342"
                            },
                            {
                                "name": "Map6",
                                "value": "Nexterra",
                                "_id": "634cee7204ebfff452429343"
                            },
                            {
                                "name": "Map7",
                                "value": "Pet Mania ",
                                "_id": "634cee7204ebfff452429344"
                            }
                        ],
                        "title2Values": [
                            {
                                "name": "Perspective1",
                                "value": "TPP"
                            },
                            {
                                "name": "Perspective2",
                                "value": "FPP"
                            }
                        ]
                    }
                },
                {
                    "_id": "637f528f29add4fac9297a33",
                    "name": "DUO",
                    "game": {
                        "titles": [
                            {
                                "name": "Map",
                                "value": "Map"
                            },
                            {
                                "name": "Perspective",
                                "value": "Perspective"
                            }
                        ],
                        "title1Values": [
                            {
                                "name": "Map1",
                                "value": "Bermuda",
                                "_id": "634cee7204ebfff45242933e"
                            },
                            {
                                "name": "Map2",
                                "value": "Bermuda Remastered",
                                "_id": "634cee7204ebfff45242933f"
                            },
                            {
                                "name": "Map3",
                                "value": "Alpain",
                                "_id": "634cee7204ebfff452429340"
                            },
                            {
                                "name": "Map4",
                                "value": "Puragatory",
                                "_id": "634cee7204ebfff452429341"
                            },
                            {
                                "name": "Map5",
                                "value": "Kalahari",
                                "_id": "634cee7204ebfff452429342"
                            },
                            {
                                "name": "Map6",
                                "value": "Nexterra",
                                "_id": "634cee7204ebfff452429343"
                            },
                            {
                                "name": "Map7",
                                "value": "Pet Mania ",
                                "_id": "634cee7204ebfff452429344"
                            }
                        ],
                        "title2Values": [
                            {
                                "name": "Perspective1",
                                "value": "TPP"
                            },
                            {
                                "name": "Perspective2",
                                "value": "FPP"
                            }
                        ]
                    }
                },
                {
                    "_id": "637f542529add4fac9297b8e",
                    "name": "SQUAD",
                    "game": {
                        "titles": [
                            {
                                "name": "Map",
                                "value": "Map"
                            },
                            {
                                "name": "Perspective",
                                "value": "Perspective"
                            }
                        ],
                        "title1Values": [
                            {
                                "name": "Map1",
                                "value": "Bermuda",
                                "_id": "634cee7204ebfff45242933e"
                            },
                            {
                                "name": "Map2",
                                "value": "Bermuda Remastered",
                                "_id": "634cee7204ebfff45242933f"
                            },
                            {
                                "name": "Map3",
                                "value": "Alpain",
                                "_id": "634cee7204ebfff452429340"
                            },
                            {
                                "name": "Map4",
                                "value": "Puragatory",
                                "_id": "634cee7204ebfff452429341"
                            },
                            {
                                "name": "Map5",
                                "value": "Kalahari",
                                "_id": "634cee7204ebfff452429342"
                            },
                            {
                                "name": "Map6",
                                "value": "Nexterra",
                                "_id": "634cee7204ebfff452429343"
                            },
                            {
                                "name": "Map7",
                                "value": "Pet Mania ",
                                "_id": "634cee7204ebfff452429344"
                            }
                        ],
                        "title2Values": [
                            {
                                "name": "Perspective1",
                                "value": "TPP"
                            },
                            {
                                "name": "Perspective2",
                                "value": "FPP"
                            }
                        ]
                    }
                },
                {
                    "_id": "65ae4843fd573b4a5b346988",
                    "name": "Clash Squad",
                    "game": {
                        "titles": [
                            {
                                "name": "Map",
                                "value": "Map"
                            },
                            {
                                "name": "Perspective",
                                "value": "Perspective"
                            }
                        ],
                        "title1Values": [
                            {
                                "name": "Map1",
                                "value": "Bermuda",
                                "_id": "634cee7204ebfff45242933e"
                            },
                            {
                                "name": "Map2",
                                "value": "Bermuda Remastered",
                                "_id": "634cee7204ebfff45242933f"
                            },
                            {
                                "name": "Map3",
                                "value": "Alpain",
                                "_id": "634cee7204ebfff452429340"
                            },
                            {
                                "name": "Map4",
                                "value": "Puragatory",
                                "_id": "634cee7204ebfff452429341"
                            },
                            {
                                "name": "Map5",
                                "value": "Kalahari",
                                "_id": "634cee7204ebfff452429342"
                            },
                            {
                                "name": "Map6",
                                "value": "Nexterra",
                                "_id": "634cee7204ebfff452429343"
                            },
                            {
                                "name": "Map7",
                                "value": "Pet Mania ",
                                "_id": "634cee7204ebfff452429344"
                            }
                        ],
                        "title2Values": [
                            {
                                "name": "Perspective1",
                                "value": "TPP"
                            },
                            {
                                "name": "Perspective2",
                                "value": "FPP"
                            }
                        ]
                    }
                }
            ],
            "hostSettings": {
                "currency": [
                    {
                        "img": "Group 7990_601a3b3f76b6e5252d2f4690_1630748859248.png",
                        "_id": "611e028e4ac17121fd8b1a17",
                        "code": "coin",
                        "BufferTime": 30
                    }
                ],
                "hostFees": 150
            }
        })
    },[])
    return (
    <ScrimContext.Provider value={{data, setData}}>
        {children}
    </ScrimContext.Provider>
    )
}
export default ScrimProvider